<template lang="html">
  <div>
    <form @submit.prevent="setPassword()" v-if="showForm === 'set-password'" id="login-form">
      <div class="inner">
        <h1 class="text-center">Set your account's password</h1>
        <div class="form-group" v-bind:class="{ error: errorPassword }">
          <label for="password">Password</label>
          <input id="password" type="password" class="form-control" placeholder="Enter your password" v-model="password">
          <div class="error">{{ errorPassword }}</div>
        </div>
        <div class="form-group" v-bind:class="{ error: errorPassword2 }">
          <label for="password2">Password again</label>
          <input id="password2" type="password" class="form-control" placeholder="Enter your password again" v-model="password2">
          <div class="error">{{ errorPassword2 }}</div>
        </div>
        <div class="text-center">
          <input type="submit" class="btn btn-primary btn-lg" value="Submit">
        </div>
        <div class="text-center">
          <router-link :to="{ name: 'login'}">Login to the system</router-link>
        </div>
      </div>
    </form>
    <form @submit.prevent="resendToken()" v-if="showForm === 'send-new-token-with-email'" id="login-form">
      <div class="inner">
        <h1 class="text-center">Oops.. the link is invalid</h1>
        <div class="form-group" v-bind:class="{ error: errorEmail }">
          <label for="email">Enter your email below in order to get a confirmation link</label>
          <input id="email" type="email" class="form-control" placeholder="Enter your email" v-model="email">
          <div class="error">{{ errorEmail }}</div>
        </div>
        <div class="text-center">
          <input type="submit" class="btn btn-primary btn-lg" value="Send confirmation link">
        </div>
        <div class="text-center">
          <router-link :to="{ name: 'login'}">Login to the system</router-link>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { HTTP } from '@/http-common'

export default {
  name: 'confirm-email',
  data () {
    return {
      password: '',
      password2: '',
      token: '',
      email: '',
      errorEmail: '',
      errorPassword: '',
      errorPassword2: '',
      showForm: 'set-password' // or: 'send-new-token', 'send-new-token-with-email'
    }
  },
  mounted () {
    this.token = this.$route.query.token

    console.log(this.token)

    if (this.token === undefined) {
      this.showForm = 'send-new-token-with-email'
    }

    if (this.token !== undefined && this.token.length === 0) {
      this.showForm = 'send-new-token-with-email'
    }

    if (this.token !== undefined) {
      this.confirmToken()
    }
  },
  methods: {
    confirmToken () {
      let data = JSON.stringify({
        token: this.token
      })

      return HTTP.post('/users/confirm_token', data, {
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }).then((response) => {
        console.log(response)
        if (response.data['errors'] !== undefined) {
          if (response.data['errors'].token !== undefined) {
            if (response.data['errors'].token === 'invalid') {
              this.showForm = 'send-new-token-with-email'
            }
          }
          if (response.data['errors'].email !== undefined) {
            if (response.data['errors'].email === 'confirmed') {
              this.showMsg('Your account is already confirmed')
              this.$router.push({ name: 'login' })
            }
          }
          return false
        } else {
          this.email = response.data['email']
          this.showForm = 'set-password'
          return true
        }
      }, (err) => {
        console.log(err)
        return false
      })
    },
    setPassword () {
      let data = JSON.stringify({
        token: this.token,
        password: this.password,
        password2: this.password2
      })

      return HTTP.post('/users/set_password', data, {
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }).then((response) => {
        console.log(response)
        if (response.data['errors'] !== undefined) {
          if (response.data['errors'].token !== undefined) {
            if (response.data['errors'].token === 'invalid') {
              this.showForm = 'send-new-token-with-email'
            }
          }
          if (response.data['errors'].email !== undefined) {
            if (response.data['errors'].email === 'confirmed') {
              this.showMsg('The account is already confirmed. Please, log in')
              this.$router.push({ name: 'login' })
            }
          }
          if (response.data['errors'].password !== undefined) {
            this.errorPassword = response.data['errors'].password
          }
          if (response.data['errors'].password2 !== undefined) {
            this.errorPassword2 = response.data['errors'].password2
          }
          return false
        } else {
          this.showMsg('You have successfully activated your account. Now you can log in', 'success')
          this.$router.push({ name: 'login' })
          return true
        }
      }, (err) => {
        console.log(err)
        return false
      })
    },
    resendToken () {
      let confirmPath = this.$router.resolve({
        name: 'confirm-email'
      }).href

      let data = JSON.stringify({
        dest_url: window.location.hostname + confirmPath,
        email: this.email
      })

      return HTTP.post('/users/resend_confirm', data, {
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      }).then((response) => {
        console.log(response)
        if (response.data['errors'] !== undefined) {
          if (response.data['errors'].email !== undefined) {
            this.errorEmail = response.data['errors'].email
          }
          return false
        } else {
          this.showMsg('The confirmation has been sent to your email')
          return true
        }
      }, (err) => {
        console.log(err)
        return false
      })
    },
    showMsg (msg, type, title) {
      this.$parent.showPopupMsg(msg, type, title)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ConfirmEmail.vue?1c63c279